import { useMutation } from "@tanstack/react-query";
import { useEngagementsInvalidate } from "PFCore/hooks/queries/engagements/use_engagements_invalidate";
import { useRolesInvalidate } from "PFCore/hooks/queries/roles/use_roles_invalidate";
import { bulkCreateOwner } from "PFCore/services/owners";
import { MutationOptions } from "PFTypes/request_options";

import { useActivityInvalidate } from "../activity/use_activity_invalidate";

export const useBulkOwnerCreate = (activityIds: number[], options: MutationOptions<number[]> = {}) => {
  const { invalidate: invalidateActivity } = useActivityInvalidate();
  const { invalidateRoles } = useRolesInvalidate();
  const { invalidateAll: invalidateEngagements } = useEngagementsInvalidate();

  return useMutation({
    mutationFn: async (profileIds: number[]) =>
      bulkCreateOwner({
        activityIds,
        profileIds
      }),
    ...options,
    onSuccess: (...args) => {
      invalidateActivity(activityIds);
      invalidateRoles();
      invalidateEngagements();
      options.onSuccess?.(...args);
    }
  });
};
